lmApp
  .controller('EpgController', ['$scope', '$rootScope', '$q', '$timeout', '$routeParams', '$location', 'EpgService', 'AssetService',
    function ($scope, $rootScope, $q, $timeout, $routeParams, $location, EpgService, AssetService) {

      $scope.loading = false;
      $scope.currentEpg = -1;
      $scope.date = {};
      $scope.searchEvent = '';
      $scope.searchFiel = '';

      $scope.collectionData = {
        empty: false
      };

      $scope.collection = [];

      $scope.getEpgCollection = function () {
        if ($scope.loading) return;

        $scope.loading = true;
        $rootScope.showLinearProgress('#epgLoader');

        AssetService.GetEpgIDCollection()
          .then(function (collection) {
            $scope.collectionData.empty = !collection.length;
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgLoader');
            $scope.collection = collection.map(function (epg) {
              epg._PrivateData = {};
              epg._PrivateData.offset = 0;
              epg._PrivateData.limit = 10;
              epg._PrivateData.lastImport = epg.last_import_time > 0 ? moment.utc(epg.last_import_time * 1000).format('lll') : '';
              return epg;
            });

            if ($scope.routeChannelId) {
              var channel = _.find($scope.collection, {id: $scope.routeChannelId});
              if (channel) {
                $scope.setActiveChannel(channel);
              }
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.getEvents = function (epg) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#epgLoader' + epg.id);

        epg._day._Events = [];

        EpgService.GetEpgEvents(epg, epg._day)
          .then(function (collection) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgLoader' + epg.id);
            epg._day._Events = collection.map(function (event) {
              event._PrivateData = {};
              event._PrivateData.startTime = moment.unix(event.start).format('HH:mm');
              event._PrivateData.endTime = moment.unix(event.end).format('HH:mm');

              return event;
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgLoader' + epg.id);
            $rootScope.debugInfo(reason);
          });
      };

      $scope.setActiveChannel = function (epg) {

        if ($scope.currentEpg !== epg.id) {
          $scope.currentEpg = epg.id;
          $scope.collapseProgramme();
          if (epg.id !== -1) {
            $location.search('channel_id', epg.id);
          } else {
            $location.search('channel_id', null);
          }
        } else {
          $scope.currentEpg = -1;
          $location.search('channel_id', null);
          return;
        }

        if ($scope.routeDate) {
          $scope.date.currentDate = moment($scope.routeDate * 1000);
        } else {
          $scope.date.currentDate = moment.utc();
          $location.search('date', $scope.date.currentDate.unix());
        }

        epg._day = {
          start: parseInt($scope.date.currentDate.startOf('day').unix(), 10),
          end: parseInt($scope.date.currentDate.endOf('day').unix(), 10),
          date: $scope.date.currentDate.endOf('day').format("D, MMMM")
        };

        if ($scope.watcher) $scope.watcher();
        $scope.watcher = $scope.$watch('date.currentDate', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $location.search('date', newValue.unix());
            $scope.collapseProgramme();
            epg._day = {
              start: parseInt(moment.utc(newValue).startOf('day').format('X'), 10),
              end: parseInt(moment.utc(newValue).endOf('day').format('X'), 10),
              date: moment.utc(newValue).endOf('day').format("D, MMMM")
            };

            $scope.getEvents(epg);
          }
        });

        $scope.getEvents(epg);
      };

      $scope.isActiveChannel = function (epg) {
        return epg.id === $scope.currentEpg;
      };

      $scope.isActiveEvent = function (event) {
        return $scope.currentProgramm && event.id === $scope.currentProgramm.id;
      };

      $scope.expandProgramme = function (event) {
        $scope.currentProgramm = event;

        EpgService.GetPoster($scope.currentProgramm.program)
          .then(function (response) {
            $scope.currentProgramm._PrivateData.picture = response;
          });
      };

      $scope.collapseProgramme = function () {
        $scope.currentProgramm = {};
      };

      $scope.routeChannelId = null;
      if ($routeParams.channel_id) {
        $scope.routeChannelId = Number($routeParams.channel_id);
      }

      $scope.routeDate = null;
      if ($routeParams.date) {
        $scope.routeDate = Number($routeParams.date);
      }

      $scope.$on('$routeUpdate', function () {
        if ($scope.routeChannelId && !$routeParams.channel_id) {
          $scope.currentEpg = -1;
          $location.search('date', null);
        }
        $scope.routeChannelId = Number($routeParams.channel_id) || null;

        $scope.routeDate = Number($routeParams.date) || null;
      });

      $scope.getEpgCollection();

      $scope.$on('destroy', function () {
        if ($scope.watcher) $scope.watcher();
      })
    }]);
